module.exports = __webpack_public_path__ + "img/instagram-white.1b41fd24.svg";